import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  ContentAnalysisV2Scope,
  ContentSentiment,
} from 'src/services/contentAnalysisApi/interfaces/contentAnalysisV2.interface'
import { ContentAnalysisV2ApiService } from 'src/services/contentAnalysisV2Api'

interface CategoryCommentsParams {
  category: string | null
  limit: number
  page: number
  sentiment?: ContentSentiment
}

export const useGetContentAnalysisCategoryCommentsQuery = (
  scope: ContentAnalysisV2Scope,
  { category, limit, page, sentiment }: CategoryCommentsParams
) =>
  useQuery({
    enabled: !!category,
    placeholderData: keepPreviousData,
    queryFn: () =>
      ContentAnalysisV2ApiService.getCategoryComments(scope, {
        category: category as string,
        limit,
        page,
        sentiment,
      }),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_CATEGORY_COMMENTS,
      category,
      sentiment,
      page,
      limit,
      scope.analysisIds?.join(','),
      scope.from,
      scope.to,
      scope.period,
      scope.platform,
    ],
  })
